export default __webpack_public_path__ + "static/media/red_flag.370c116c.svg";